import { render, staticRenderFns } from "./_table.component.vue?vue&type=template&id=3d3566eb&scoped=true&"
import script from "./_table.component.vue?vue&type=script&lang=js&"
export * from "./_table.component.vue?vue&type=script&lang=js&"
import style0 from "./_table.component.vue?vue&type=style&index=0&id=3d3566eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3566eb",
  null
  
)

export default component.exports